import { render } from "./HighchartSpiderChart.vue?vue&type=template&id=587fb162&ts=true"
import script from "./HighchartSpiderChart.vue?vue&type=script&lang=ts"
export * from "./HighchartSpiderChart.vue?vue&type=script&lang=ts"

import "./HighchartSpiderChart.vue?vue&type=style&index=0&id=587fb162&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__